// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { lazy } from 'react'
import { UserManagementAreaId } from './UserManagementAreaId'
import { UserManagementAreaNavigation } from './UserManagementAreaNavigation'
import { UserManagementAreaRoutes } from './UserManagementAreaRoutes'

const LazyUserManagementComponent = lazy(() => import('./UserManagementArea'))

const UserManagementComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyUserManagementComponent />
  </SuspenseLoadingWrapper>
)

export const UserManagementArea = {
  id: UserManagementAreaId,
  NavigationComponent: UserManagementAreaNavigation,
  route: {
    path: UserManagementAreaRoutes.route,
    component: UserManagementComponent,
  },
}
